import React from "react";
import "./YoutubeLogo.css";

export function YoutubeLogo() {
  return (
    <>
      <img src={'/images/youtube-logo.png'} alt="YouTube Logo" className="youtube-logo" />
    </>
  );
}
